<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-logo">
        <a href="/"><b>Admin</b>CRM</a>
      </div>
      <div class="login-box-body">
        <form>
          <div class="form-group has-feedback" v-bind:class="errorUsername ? 'has-error' : ''">
            <input type="email" class="form-control" placeholder="Tài khoản" v-model="username">
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
          </div>
          <div class="form-group has-feedback" v-bind:class="errorPassword ? 'has-error' : ''">
            <input type="password" class="form-control" placeholder="Mật khẩu" v-model="password">
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <button @click.prevent="loginAction" class="btn btn-primary btn-block btn-flat" :disabled="loading">
                <b-spinner small v-show="loading" class="align-middle"></b-spinner>
                <span v-show="!loading">Đăng nhập</span>
              </button>
            </div>
          </div>
        </form>
        <div class="text-danger text-center mt-3" v-show="errorMsg">{{errorMsg}}</div>
      </div>
      <div class="text-center mt-3">
        <b-link @click="$router.push('/terms')">
          Điều khoản sử dụng - Chính sách bảo mật
        </b-link>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import authAPI from '../api/auth'
import router from '../router'
import {Constant, ERROR_CODE, PERMISSION_KEY, ROUTING} from '../common/constant'
import Cookies from 'js-cookie'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      errorMsg: null,
      loading: false,
      click: false
    }
  },
  computed: {
    errorUsername: function () {
      return this.isEmpty(this.username)
    },
    errorPassword: function () {
      return this.isEmpty(this.password)
    },
  },
  methods: {
    ...mapActions([
      'login',
      'updateUser',
      'updateMenu',
      'updatePermission'
    ]),
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    validate () {
      return !this.errorPassword && !this.errorUsername
    },
    loginAction () {
      this.click = true
      this.loading = true
      if (!this.validate()) {
        this.loading = false
        this.errorMsg = 'Vui lòng nhập tài khoản/mật khẩu'
        return
      }
      authAPI.login(this.username, this.password).then(res => {
        if (res.data.code === 1001) {
          this.errorMsg = 'Tài khoản hoặc mật khẩu không đúng'
          return
        }
        const token = res.data.access
        const refresh = res.data.refresh
        this.login({token, refresh})
        authAPI.getUserInfo().then(res => {
          this.loading = false
          if (res.data.data) {
            const userInfo = res.data.data
            this.updateUser({userInfo})
            this.updateMenu({userInfo})
            this.updatePermission({userInfo})
            let menus = Cookies.get(Constant.MENU_PERMISSIONS)
            if (menus.includes(PERMISSION_KEY.DATA_MANAGEMENT)) {
              router.push({name: 'OrderList'})
            } else {
              const listMenu = JSON.parse(menus)
              router.push({name: ROUTING[listMenu[0]]})
            }
            window.location.reload()
          }
        }).catch(err => {
          this.loading = false
          if (err.response.status === 401 || err.response.status === 400) {
            this.errorMsg = ERROR_CODE[err.response.data.code]
          }
        })
      }).catch(err => {
        this.loading = false
        if (err && err.response && err.response.status === 401) {
          this.errorMsg = ERROR_CODE[err.response.data.code]
        } else {
          this.errorMsg = ERROR_CODE['2']
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.login-box-body {
  .form-control {
    height: 34px;
  }

  button {
    height: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue